var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"m-0 the-rating",class:{ 'the-rating--locked': _vm.isLocked }},_vm._l((_vm.stars),function(starType,index){return _c('li',{key:index,staticClass:"star",class:starType,on:{"click":function($event){return _vm.$emit('rate', index + 1)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }